<template>
  <div class="text-textColor overflow-hidden">
    <transition name="fade">
      <div
        v-if="showReviewWorkflowUserGroup"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full overflow-hidden"
      >
        <div
          class="fixed overflow-y-auto max-h-screen center-h-v bg-white rounded-md shadow-2xl sm:w-3/5 w-full p-2"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <transition name="fade">
            <div
              v-if="create_success"
              class="p-1 text-center text-white text-sm w-full bg-green-200"
            >
              {{ create_success }}
            </div>
          </transition>
          <transition name="fade">
            <div
              v-if="create_error"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ create_error }}
            </div>
          </transition>
          <div class="flex justify-between items-center border-b-1.5 p-3">
            <p class="text-base">
              {{ workflowToReview.Name }} - {{ workflowToReview.Department }}
            </p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>

          <div class="grid grid-cols-1 px-0.5 py-2 gap-5">
            <div class="text-sm">
              <label class="block pb-1">Workflow Name</label>
              <input
                v-model="workflowToReview.Name"
                type="text"
                required
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>
          </div>

          <div class="grid grid-cols-1 px-0.5 py-2 gap-5">
            <div class="text-sm">
              <label class="block pb-1">Company</label>
              <el-select
                filterable
                class="bg-gray-200 rounded-full w-full border-none"
                v-model="workflowToReview.Location"
                placeholder="Enter a company"
                @change="getLocationById"
              >
                <el-option
                  v-for="location in locations"
                  :key="location.Id"
                  :label="location.Location"
                  :value="location.Location"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="grid grid-cols-1 px-0.5 py-2 mb-2 gap-5">
            <div class="text-sm">
              <label class="block pb-1">Department</label>
              <el-select
                filterable
                class="bg-gray-200 rounded-full w-full border-none"
                v-model="workflowToReview.Department"
                placeholder="Enter a department"
              >
                <el-option
                  v-for="department in departments"
                  :key="department.Id"
                  :label="department.Name"
                  :value="department.Name"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <el-card class="box-card mb-5">
            <div slot="header" class="clearfix">
              <span>Workflow Approvers</span>
            </div>
            <div class="p-2">
              <div class="flex justify-between items-start mb-3">
                <div class="col-span-1">
                  <!-- <label class="block pb-1">Leave Workflow Group Users</label> -->
                  <el-select
                    filterable
                    v-model="selectedUser"
                    placeholder="Select a approver"
                    class="w-full"
                    size="small"
                  >
                    <el-option
                      v-for="employee in getEmployees"
                      :key="employee.Id"
                      :label="
                        decryptDataLocal(employee.Fullname, decryptionKey)
                      "
                      :value="employee.Id"
                    ></el-option>
                  </el-select>
                </div>
                <div class="col-span-1">
                  <!-- <label class="block pb-1">Sequence</label> -->
                  <el-input
                    size="small"
                    v-model.number="sequenceNumber"
                    type="number"
                    placeholder="Select a sequence"
                    required
                    class="w-full"
                  ></el-input>
                </div>
                <div class="col-span-1 flex items-start">
                  <div
                    class="flex items-center gap-2"
                    v-if="sequenceNumber && selectedUser"
                  >
                    <button
                      @click="() => addUserToWorkflow('approver')"
                      class="border-1.5 flex rounded-full py-2 px-1.5 gap-1 bg-primaryDark hover:bg-primary hover:text-gray-200 text-white border-primary capitalize"
                    >
                      <img class="h-5" src="@/assets/icons/add.svg" />
                      Save
                    </button>
                  </div>
                </div>
              </div>

              <el-table
                :data="decrypt(workflowToReview.Approvers, 'Approver')"
                stripe
                style="width: 100%"
                height="150"
                overflowY="scroll"
              >
                <el-table-column
                  type="index"
                  label="#"
                  width="50"
                ></el-table-column>
                <el-table-column
                  prop="Approver"
                  label="Approverss"
                  width="auto"
                ></el-table-column>
                <el-table-column
                  prop="SequenceNo"
                  label="Sequence"
                  width="150"
                ></el-table-column>
                <el-table-column label="Actions" width="150">
                  <template slot-scope="scope">
                    <ve-popper trigger="clickToOpen">
                      <div class="bg-white shadow-md popper">
                        <button
                          class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                          style="boder-radius: 0 !important"
                          @click="removeApprover(scope.$index)"
                        >
                          Delete
                        </button>

                        <!-- <button
                          class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                          style="boder-radius: 0 !important"
                          @click="editApprover(scope.$index)"
                        >
                          Edit
                        </button> -->
                      </div>

                      <button slot="reference">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          id="Outline"
                          viewBox="0 0 24 24"
                          width="20"
                          height="20"
                        >
                          <circle cx="12" cy="2" r="2" />
                          <circle cx="12" cy="12" r="2" />
                          <circle cx="12" cy="22" r="2" />
                        </svg>
                      </button>
                    </ve-popper>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-card>

          <!-- Add members -->
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>Workflow Members</span>
            </div>
            <!-- {{ workflowToReview }} -->
            <div class="p-2">
              <div class="flex justify-end items-end w-full mb-3">
                <div class="flex items-end gap-2">
                  <button
                    @click="showAddMemberToLeaveWorkflow = true"
                    class="border-1.5 flex gap-1 rounded-full py-2 px-1.5 bg-primaryDark hover:bg-primary hover:text-gray-200 text-white border-primary capitalize"
                  >
                    <img class="h-5" src="@/assets/icons/add.svg" />
                    Member
                  </button>
                  <button
                    @click="() => handleBulkUploadClick('members')"
                    class="border-1.5 flex rounded-full py-2 px-1.5 bg-primaryDark hover:bg-primary hover:text-gray-200 text-white border-primary capitalize"
                  >
                    <img class="h-5" src="@/assets/icons/export-excel.png" />
                    Import
                  </button>

                  <button
                    @click="() => exportTemplate('members')"
                    class="border-1.5 flex rounded-full py-2 px-1.5 bg-primaryDark hover:bg-primary hover:text-gray-200 text-white border-primary capitalize"
                  >
                    <img class="h-5" src="@/assets/icons/export-excel.png" />
                    Export
                  </button>
                </div>
              </div>

              <el-table
                :data="decrypt(workflowToReview.Members, 'Name')"
                stripe
                style="width: 100%"
                height="150"
                overflowY="scroll"
              >
                <el-table-column
                  type="index"
                  label="#"
                  width="50"
                ></el-table-column>

                <el-table-column
                  prop="EmployeeNo"
                  label="Employee No"
                  width="150"
                ></el-table-column>
                <el-table-column
                  prop="Name"
                  label="Name"
                  width="auto"
                ></el-table-column>
                <el-table-column label="Actions" width="150">
                  <template slot-scope="scope">
                    <ve-popper trigger="clickToOpen">
                      <div class="bg-white shadow-md popper">
                        <button
                          class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                          style="boder-radius: 0 !important"
                          @click="() => removeMember(scope.$index)"
                        >
                          Remove
                        </button>
                      </div>

                      <button slot="reference">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          id="Outline"
                          viewBox="0 0 24 24"
                          width="20"
                          height="20"
                        >
                          <circle cx="12" cy="2" r="2" />
                          <circle cx="12" cy="12" r="2" />
                          <circle cx="12" cy="22" r="2" />
                        </svg>
                      </button>
                    </ve-popper>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-card>
        </div>
      </div>
    </transition>
    <BulkUpload
      v-if="showBulkUpload"
      :close="closeBulkUpload"
      :showBulkUpload="showBulkUpload"
      :showBulkUploadCallback="showBulkUploadCallback"
      title="Timeoff Workflow Users Bulk Upload"
      dataType="UploadTimeoffWorkflowMembers"
      :url="url"
      :dateColumns="[]"
      :columns="timeoffWorkflowUsersBulkUploadColumns"
    ></BulkUpload>
    <AddMemberToLeaveWorkflow
      :showAddMemberToLeaveWorkflow="showAddMemberToLeaveWorkflow"
      @close="showAddMemberToLeaveWorkflow = false"
      :workFlowName="workflowToReview"
      :getWorkflow="getWorkflow"
      :getNewMember="getNewMember"
    ></AddMemberToLeaveWorkflow>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Loader from '@/components/loader/loader.vue';
import axios from 'axios';
import { importTemplateGenerator } from '@/utils/importTemplateGenerator';
import timeoffWorkflowUsersBulkUploadColumns from '../../../data/timeoffWorkflowUsersBulkUploadColumns';
import AddMemberToLeaveWorkflow from './addMemberToWorkflow.vue';
import decryptData from '@/utils/decrypt';

export default {
  name: 'CompanySetupReviewWorkflowUserGroup',
  props: ['showReviewWorkflowUserGroup', 'workflowToReview', 'getWorkflow'],
  components: {
    Loader,
    BulkUpload: () => import('@/utils/bulkUploadsUtils.vue'),
    AddMemberToLeaveWorkflow,
  },
  data() {
    return {
      decryptDataLocal: '',
      decryptionKey: '',
      showAddMemberToLeaveWorkflow: false,
      timeoffWorkflowUsersBulkUploadColumns: null,
      url: `/setup/timeoff/workflow/member/${this.$ApiVersion}/upload`,
      showBulkUpload: false,
      locations: [],
      reason: '',
      loading: false,
      departments: [],
      isEditing: false,
      create_success: null,
      create_error: null,
      get_error: null,
      employees: [],
      rowStyleOption: {
        clickHighlight: false,
        hoverHighlight: false,
      },
      workflowData: {
        WorkflowId: '',
        ApproverId: '',
        SequenceNo: 0,
        LocationId: '',
      },
      submitData: [],
      cellSelectionOption: {
        enable: false,
      },
      columns: [
        {
          field: '',
          key: 'numbering',
          title: '#',
          width: 10,
          align: 'center',
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },

        {
          field: 'EmployeeNo',
          key: 'EmployeeNo',
          title: 'EmployeeNo',
          headerAlign: 'left',
          align: 'left',
          sampleValue: 'EMPLOYEE-01',
        },
        {
          field: 'WorkflowName',
          key: 'WorkflowName',
          title: 'Workflow Name',
          headerAlign: 'left',
          align: 'left',
          sampleValue: 'Sepia Leave Application',
        },
      ],
      tableData: [],
      selectedUser: '',
      selectedMember: '',
      sequenceNumber: '',
    };
  },

  computed: {
    ...mapGetters([
      'getOrganization',
      'getToken',
      'getCurrentWorkflow',
      'getEmployees',
    ]),
  },
  created() {
    this.decryptDataLocal = decryptData;
    this.decryptionKey = this.$decryptionKey;
    this.timeoffWorkflowUsersBulkUploadColumns =
      timeoffWorkflowUsersBulkUploadColumns;
    this.getLocations();
    this.getDepartments();
  },
  methods: {
    decrypt(data, attributeName) {
      return data.map((member) => {
        return {
          ...member,
          [attributeName]: decryptData(
            member[attributeName],
            this.$decryptionKey
          ),
        };
      });
    },
    getNewMember({ UploadTimeoffWorkflowMembers }) {
      UploadTimeoffWorkflowMembers = UploadTimeoffWorkflowMembers.map(
        (member) => {
          return {
            ...member,
            ['Name']: member['MemberName'],
          };
        }
      );

      this.workflowToReview.Members.push(...UploadTimeoffWorkflowMembers);
    },
    // /{organization}/setup/leave/workflow/members/v1/delete

    removeMember(index) {
      const { Members } = this.workflowToReview;
      const { Id } = Members[index]; // This is EmployeeId

      this.loading = true;
      axios
        .delete(
          `${this.getOrganization}/setup/leave/workflow/members/v1/delete`,
          {
            headers: {
              Authorization: `Bearer ${this.getToken}`,
              'Content-Type': 'application/json',
            },
            data: {
              employeeId: Id, // key must match the backend DTO exactly
            },
          }
        )
        .then(
          (response) => {
            if (response.data.StatusCode === 200) {
              this.loading = false;
              this.getWorkflow(index);
              this.$notify({
                title: 'Success',
                message: response.data.StatusMessage,
                type: 'success',
              });
              setTimeout(() => {
                this.delete_success = null;
              }, 2500);
            } else {
              this.loading = false;
              this.getWorkflow(index);
              this.$notify.error({
                title: 'Failure',
                message: response.data.StatusMessage,
              });
            }
          },
          (error) => {
            this.loading = false;
            this.$notify.error({ title: 'Failure', message: error.message });

            setTimeout(() => {
              this.delete_error = null;
            }, 2500);
          }
        );
    },

    handleBulkUploadClick(type) {
      if (type === 'approvers') {
        this.url = `/setup/timeoff/workflow/bulk/${this.$ApiVersion}/upload`;
      } else {
        this.url = `/setup/timeoff/workflow/member/${this.$ApiVersion}/upload`;
      }
      this.showBulkUpload = true;
    },
    showBulkUploadCallback() {
      this.showBulkUpload = false;
      this.getWorkflow();
    },
    closeBulkUpload() {
      this.showBulkUpload = false;
    },

    exportTemplate(type) {
      if (type === 'approvers') {
        importTemplateGenerator(
          this.columns.filter((c) => c.title !== '#'),
          'UploadTimeoffWorkflowMembers',
          [
            {
              EmployeeNo: '01',
              Sequence: 0,
            },
          ]
        );
      } else {
        importTemplateGenerator(
          this.columns.filter((c) => c.title !== '#'),
          'UploadTimeoffWorkflowMembers'
        );
      }
    },
    async addUserToWorkflow() {
      // this.loading = true;

      this.url = `/setup/timeoff/workflow/approver/${this.$ApiVersion}/add`;

      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          'Content-Type': ' application/json',
        },
      };
      // Check if the user and sequence are selected
      if (this.selectedUser && this.sequenceNumber !== '') {
        // Find the employee by Fullname
        const selectedEmployee = this.getEmployees.find(
          (employee) => employee.Id === this.selectedUser
        );

        // Create a new user group member object
        const newUserGroupMember = {
          WorkflowId: this.workflowToReview.Id,
          Approver: selectedEmployee.Fullname,
          SequenceNo: this.sequenceNumber,
          ApproverId: selectedEmployee.Id, // Assuming the employee has a unique ID
        };

        // /{organization}/setup/leave/workflow/members/v1/add
        try {
          const response = await axios.post(
            `${this.getOrganization}${this.url}`,
            JSON.stringify(newUserGroupMember),
            options
          );
          if (response.data.StatusCode == 200) {
            this.create_success = response.data.StatusMessage;
            this.$notify({
              title: 'Success',
              message: response.data.StatusMessage,
              type: 'success',
            });
            // Add the new user group member to the workflow
            this.getWorkflow();
            this.workflowToReview =
              this.workflowToReview.Approvers.push(newUserGroupMember);

            setTimeout(() => {
              this.create_success = null;
            }, 2000);
          } else {
            this.create_error = response.data.StatusMessage;
            setTimeout(() => {
              this.create_error = null;
            }, 2000);
          }
        } catch (error) {
          this.create_error = error.message;
          setTimeout(() => {
            this.create_error = null;
          }, 2000);
        }

        this.workflowToReview.Approvers.push(newUserGroupMember);
        // Clear the form fields
        this.selectedUser = '';
        this.sequenceNumber = '';
      }
    },

    async unassignLeaveType(employeeId, employeeLeaveTypeId) {
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
        data: {
          EmployeeId: employeeId,
          EmployeeLeaveTypeId: employeeLeaveTypeId,
        },
      };
      try {
        // Make an API call to unassign the leave type
        const response = await axios.delete(
          `${this.getOrganization}/employee/leave/type/${this.$ApiVersion}/delete`,

          options
        );

        this.loading = true;
        if (response.data.StatusCode === 200) {
          this.loading = false;
          this.delete_success = response.data.StatusMessage;
          setTimeout(() => {
            this.delete_success = null;
          }, 2000);
        } else {
          this.loading = false;
          this.delete_error = response.data.StatusMessage;
          setTimeout(() => {
            this.delete_error = null;
          }, 2000);
        }
      } catch (error) {
        this.loading = false;
        this.cancel_error = error.message;
        setTimeout(() => {
          this.cancel_error = null;
        }, 2000);
      }
    },

    async removeApprover(index) {
      // alert(1);
      // this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          'Content-Type': ' application/json',
        },
        data: {
          ApproverId: this.workflowToReview.Approvers[index].Id,
        },
      };
      // Remove the user from the workflow based on the index
      // const leaveWorkflowMemberId = this.workflowToReview.Approvers[index].Id;

      // /{organization}/setup/leave/workflow/members/{leaveWorkflowMemberId}/v1/delete
      // /{organization}/setup/leave/workflow/members/v1/add
      // /setup/timeoff/workflow/approver/v1/delete
      try {
        const response = await axios.delete(
          `${this.getOrganization}/setup/timeoff/workflow/approver/${this.$ApiVersion}/delete`,

          options
        );
        if (response.data.StatusCode == 200) {
          this.workflowToReview = this.workflowToReview.Approvers.splice(
            index,
            1
          );
          this.create_success = response.data.StatusMessage;
          this.$notify({
            title: 'Success',
            message: response.data.StatusMessage,
            type: 'success',
          });
          this.getWorkflow();
          setTimeout(() => {
            this.create_success = null;
          }, 2000);
        } else {
          this.create_error = response.data.StatusMessage;
          setTimeout(() => {
            this.create_error = null;
          }, 2000);
        }
      } catch (error) {
        this.create_error = error.message;
        setTimeout(() => {
          this.create_error = null;
        }, 2000);
      }
      this.workflowToReview.Approvers.splice(index, 1);
    },

    async editApprover(index) {
      // this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          'Content-Type': ' application/json',
        },
      };
      // Remove the user from the workflow based on the index
      const leaveWorkflowMemberId = this.workflowToReview.Approvers[index].Id;

      // /{organization}/setup/leave/workflow/members/{leaveWorkflowMemberId}/v1/delete
      // /{organization}/setup/leave/workflow/members/v1/add
      try {
        const response = await axios.put(
          `${this.getOrganization}/setup/leave/workflow/members/${leaveWorkflowMemberId}/${this.$ApiVersion}/delete`,

          options
        );
        if (response.data.StatusCode == 200) {
          this.workflowToReview = this.workflowToReview.Approvers.splice(
            index,
            1
          );
          this.create_success = response.data.StatusMessage;
          this.$notify({
            title: 'Success',
            message: response.data.StatusMessage,
            type: 'success',
          });

          this.getWorkflow();
          setTimeout(() => {
            this.create_success = null;
          }, 2000);
        } else {
          this.create_error = response.data.StatusMessage;
          setTimeout(() => {
            this.create_error = null;
          }, 2000);
        }
      } catch (error) {
        this.create_error = error.message;
        setTimeout(() => {
          this.create_error = null;
        }, 2000);
      }
      this.workflowToReview.Approvers.splice(index, 1);
    },

    close() {
      this.$emit('close');
      this.tableData = [
        {
          Approver: '',
          SequenceNo: '',
          Id: '',
        },
      ];
    },

    async fetchLocations(queryString, callback) {
      if (queryString) {
        const locationsFound = this.locations.filter((location) =>
          location.Name.toLowerCase().includes(queryString.toLowerCase())
        );
        callback(locationsFound);
        return;
      }
      // //console.log(this.locations)
      callback(this.locations);
    },

    async fetchDepartments(queryString, callback) {
      if (queryString) {
        const departmentsFound = this.departments.filter((department) =>
          department.Department.toLowerCase().includes(
            queryString.toLowerCase()
          )
        );
        callback(departmentsFound);
        return;
      }
      // //console.log(this.departments)
      callback(this.departments);
    },

    findLocationById(LocationId) {
      this.workflowToReview.Location = this.locations.find(
        (location) => location.Id === LocationId
      ).Name;
    },

    getEmployeeById(EmployeeId) {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/employee/${EmployeeId}/general/${this.$ApiVersion}/info`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              //console.log(response.data);
              // //console.log(this.employees)
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },

    async getLocationById(locationSelected) {
      const locationId = this.locations.find(
        (location) => location.Name === locationSelected
      ).Id;
      console.log(locationId);
      this.getDepartments(locationId);
      this.departmentsAtSelectedCompany = this.departments.filter(
        (dep) => dep.Name
      );

      this.info.DepartmentId = this.departments.find(
        (department) => department.Department === this.info.DepartmentId
      ).DepartmentId;
    },
    // /{organization}/setup/department/v1/request
    getDepartments() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/department/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.departments = response.data.Data;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },

    getDepartmentById(e, departmentSelected) {
      const departmentId = this.departments.find(
        (department) => department.Name === departmentSelected
      ).Id;
      this.getDepartments(departmentId);
    },

    getLocations() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/location/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              // //console.log(response.data.Data)
              this.locations = response.data.Data.map((location) => {
                return { ...location, Location: location.Name };
              });
              this.locations.forEach((v, index) => {
                v.rowKey = `${index + ``}`;
                v.departments = [];
              });
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
